var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBookerTowable = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.5 15.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M0 6a2.75 2.75 0 0 1 2.75-2.75h15A2.75 2.75 0 0 1 20.5 6v8.5a2.75 2.75 0 0 1-2.75 2.75H8a.75.75 0 0 1 0-1.5h9.75c.69 0 1.25-.56 1.25-1.25V6c0-.69-.56-1.25-1.25-1.25h-15c-.69 0-1.25.56-1.25 1.25v8.5c0 .69.56 1.25 1.25 1.25H5a.75.75 0 0 1 0 1.5H2.75A2.75 2.75 0 0 1 0 14.5z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.25 7a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-1.5 0V7.75h-2.5V16a.75.75 0 0 1-1.5 0z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15 16.5a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M21 18v-3a.75.75 0 0 1 1.5 0v3a.75.75 0 0 1-1.5 0M0 12.25a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75m16 0a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75",
  clipRule: "evenodd"
})));
export default SvgBookerTowable;